module.exports = __webpack_public_path__ + "img/Carta-Blanca-Media.c8551723.png";